"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoise = void 0;
const eql_1 = require("./eql");
const memoise = (f) => {
    const state = [];
    return (...args) => {
        const last = state.find(e => (0, eql_1.eql)(e[0], args));
        if (last)
            return last[1];
        const call = f(...args);
        state.push([args, call]);
        return call;
    };
};
exports.memoise = memoise;
//# sourceMappingURL=memoise.js.map